import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { APIClient } from '../misc/APIClient';
export var NotificationAPI = /*#__PURE__*/function (_APIClient) {
  function NotificationAPI() {
    _classCallCheck(this, NotificationAPI);
    return _callSuper(this, NotificationAPI, arguments);
  }
  _inherits(NotificationAPI, _APIClient);
  return _createClass(NotificationAPI, [{
    key: "find",
    value: function find(params) {
      return this.client.get("/v3/notifications", {
        params: params
      }).then(this._data);
    }
  }, {
    key: "changeStatus",
    value: function changeStatus(id, payload) {
      return this.client.post("/v3/notifications/".concat(id, "/status"), payload).then(this._data);
    }
  }, {
    key: "changeStatusBulk",
    value: function changeStatusBulk(payload) {
      return this.client.post("/v3/notifications/status", payload).then(this._data);
    }
  }]);
}(APIClient);
export var NotificationPreferencesAPI = /*#__PURE__*/function (_APIClient2) {
  function NotificationPreferencesAPI() {
    _classCallCheck(this, NotificationPreferencesAPI);
    return _callSuper(this, NotificationPreferencesAPI, arguments);
  }
  _inherits(NotificationPreferencesAPI, _APIClient2);
  return _createClass(NotificationPreferencesAPI, [{
    key: "get",
    value: function get() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        workspace_id = _ref.workspace_id,
        _ref$user_id = _ref.user_id,
        user_id = _ref$user_id === void 0 ? 'me' : _ref$user_id;
      return this.client.get("/v3/workspaces/".concat(workspace_id, "/members/").concat(user_id, "/preferences")).then(this._data);
    }
  }, {
    key: "patch",
    value: function patch() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        workspace_id = _ref2.workspace_id,
        _ref2$user_id = _ref2.user_id,
        user_id = _ref2$user_id === void 0 ? 'me' : _ref2$user_id;
      var payload = arguments.length > 1 ? arguments[1] : undefined;
      return this.client.patch("/v3/workspaces/".concat(workspace_id, "/members/").concat(user_id, "/preferences"), payload).then(this._data);
    }
  }]);
}(APIClient);
//# sourceMappingURL=API.js.map
